import { fetchData, getBlobData, postData } from "./apis";

const path = "/hrpayroll";

export const getEmployeeBySearchApi = (value) => {
  let endPoint = `${path}/get-employees-by-search`;
  return postData(endPoint, value);
};

export const saveEmployeeApi = (value) => {
  let endPoint = `${path}/save-employee`;
  return postData(endPoint, value);
};

export const saveEmployeeFileApi = (value) => {
  let endPoint = `${path}/save-employee-file`;
  return postData(endPoint, value);
};

export const saveFinalSettlementApi = (value) => {
  let endPoint = `${path}/final-settlement/save`;
  return postData(endPoint, value);
};

export const getFinalSettlementApi = (employeeId) => {
  return fetchData(`${path}/final-settlement/${employeeId}`);
};

export const calculateFinalSettlementApi = (value) => {
  let endPoint = `${path}/final-settlement/calculate`;
  return postData(endPoint, value);
};

export const gratuityCalculatorApi = (value) => {
  let endPoint = `${path}/gratuity-calculator`;
  return postData(endPoint, value);
};

export const saveEmployeeListApi = (value) => {
  let endPoint = `${path}/save-employees`;
  return postData(endPoint, value);
};

export const saveEmployeePaymentApi = (value) => {
  let endPoint = `${path}/save-employee-payment`;
  return postData(endPoint, value);
};

export const getEmployeePayableAmountApi = (value) => {
  let endPoint = `${path}/get-employee-payable-amount`;
  return postData(endPoint, value);
};

export const downloadEmployeeHistoryApi = (employeeId) => {
  return getBlobData(`${path}/export-employee-history/${employeeId}`);
};

export const downloadSalaryHistoryApi = (employeeId) => {
  return getBlobData(`${path}/export-salary-history/${employeeId}`);
};

export const hasEmployeeHistoryApi = (employeeId) => {
  return fetchData(`${path}/has-employee-history/${employeeId}`);
};

export const getLeaveRequestDetailApi = (leaveRequestId) => {
  return fetchData(`${path}/leave-requests/${leaveRequestId}`);
};

export const hasSalaryHistoryApi = (employeeId) => {
  return fetchData(`${path}/has-salary-history/${employeeId}`);
};

export const getEffectiveSalaryApi = (employeeId, month, year) => {
  return fetchData(
    `${path}/effective-salary/${employeeId}?month=${month}&year=${year}`,
  );
};

export const generateSalaryCertificateApi = (data, config = {}) => {
  return postData(`${path}/generate-salary-certificate`, data, {
    responseType: "blob",
    ...config,
  });
};
//for puppeteer
export const getPublicPayslip = async (token) => {
  const hostname =
    process.env.REACT_APP_API_FRONTEND_PORT == "443"
      ? process.env.REACT_APP_API_HOSTNAME + "/api"
      : process.env.REACT_APP_API_HOSTNAME;
  const newpath = hostname + "/hrpayroll";
  const res = await fetch(`${newpath}/payslip/public-payslip?token=${token}`);
  if (!res.ok) {
    throw new Error("Failed to fetch payslip");
  }

  return await res.json();
};

export const getEmployeeCodeApi = (value) => {
  let endPoint = `${path}/get-employee-code`;
  return postData(endPoint, value);
};

export const getCurrentEmployeeApi = (employee_id) => {
  let endPoint = `${path}/get-current-employee`;
  return postData(endPoint, { employee_id });
};

export const getDepartmentsApi = (value) => {
  let endPoint = `${path}/get-departments`;
  return postData(endPoint, value);
};

export const saveDepartmentApi = (value) => {
  let endPoint = `${path}/save-department`;
  return postData(endPoint, value);
};

export const deleteDepartmentApi = (value) => {
  let endPoint = `${path}/delete-department`;
  return postData(endPoint, value);
};

export const getDesignationApi = (value) => {
  let endPoint = `${path}/get-designations`;
  return postData(endPoint, value);
};

export const getOnboardings = () => {
  let endPoint = `${path}/onboarding-list`;
  return fetchData(endPoint);
};

export const getSingleOnboarding = (value) => {
  let endPoint = `${path}/onboarding/get-single`;
  return postData(endPoint, value);
};

export const saveOnboardingApi = (value) => {
  let endPoint = `${path}/onboarding-save`;
  return postData(endPoint, value);
};

export const convertToEmployeeApi = (value) => {
  let endPoint = `${path}/onboarding/convert-to-employee`;
  return postData(endPoint, { id: value });
};

export const updateJoiningStatusApi = (data) =>
  postData(`${path}/onboarding/update-joining-status`, data );

export const deleteEmployeeApi = (value) => {
  let endPoint = `${path}/delete-employee`;
  return postData(endPoint, value);
};

export const saveGroupManageApi = (value) => {
  let endPoint = `${path}/save-group-manage`;
  return postData(endPoint, value);
};

export const getSalaryPaymentWithDetailsApi = (value) => {
  let endPoint = `${path}/get-salary-payment-with-details`;
  return postData(endPoint, value);
};

export const getPaymentCodeApi = (value) => {
  let endPoint = `${path}/get-payment-code`;
  return postData(endPoint, value);
};

export const deleteSalaryPaymentApi = (value) => {
  let endPoint = `${path}/delete-salary-payment`;
  return postData(endPoint, value);
};

export const approveSalaryPaymentApi = (value) => {
  let endPoint = `${path}/approve-salary-payment`;
  return postData(endPoint, value);
};

export const saveDesignationApi = (value) => {
  let endPoint = `${path}/save-designation`;
  return postData(endPoint, value);
};

export const deleteDesignationApi = (value) => {
  let endPoint = `${path}/delete-designation`;
  return postData(endPoint, value);
};

export const attendanceMonthlySummaryApi = (value) => {
  let endPoint = `${path}/attendance-monthly-summary`;
  return postData(endPoint, value); // <--- uses POST properly
};

export const attendanceMonthlyPayrollSummaryApi = (value) => {
  let endPoint = `${path}/attendance-monthly-payroll-summary`;
  return postData(endPoint, value); // <--- uses POST properly
};

export const getEmployeeAttendanceSummaryApi = (payload) =>
 postData(
    `${path}/get-employee-attendance-summary`,
    payload
  );

export const getEmployeeMonthlyPayDetailsApi = (value) => {
  let endPoint = `${path}/employee-monthly-pay-details`;
  return postData(endPoint, value);
};

export const getTodayAttendanceOverviewApi = (value) => {
  let endPoint = `${path}/get-today-attendace-overview`;
  return postData(endPoint, value);
};

export const getEmployeeUsersApi = (value) => {
  let endPoint = `${path}/get-emp-users`;
  return postData(endPoint, value);
};

export const getAttendanceCalenderApi = (value) => {
  let endPoint = `${path}/get-attendance-calender`;
  return postData(endPoint, value);
};

export const markAttendanceApi = (value) => {
  let endPoint = `${path}/mark-attendance`;
  return postData(endPoint, value);
};

export const attendanceRegularizeApi = (value) => {
  let endPoint = `${path}/attendance-regularize`;
  return postData(endPoint, value);
};

export const leaveAttendanceApi = (value) => {
  let endPoint = `${path}/leave-attendance`;
  return postData(endPoint, value);
};

export const addHolidayApi = (value) => {
  let endPoint = `${path}/add-holiday`;
  return postData(endPoint, value);
};

export const addRestrictedHolidayApi = (value) => {
  let endPoint = `${path}/add-restricted-holiday`;
  return postData(endPoint, value);
};

export const getAttendanceEmployeeApi = (value) => {
  let endPoint = `${path}/get-attendance-employees`;
  return postData(endPoint, value);
};

export const saveAllAttendanceApi = (value) => {
  let endPoint = `${path}/save-all-attendance`;
  return postData(endPoint, value);
};

export const saveAttendanceApi = (value) => {
  let endPoint = `${path}/save-attendance`;
  return postData(endPoint, value);
};

export const bulkMarkPresentApi = (data) => {
  let endPoint = `${path}/bulk-mark-present`;
  return postData(endPoint, data);
};

export const getLeaveDetailsApi = (value) => {
  let endPoint = `${path}/get-emp-leave-details`;
  return postData(endPoint, value);
};

export const getEmployeeLeaveSummaryApi = (value) => {
  let endPoint = `${path}/get-employee-leave-summary`;
  return postData(endPoint, value);
};

export const getUserAttendancePendingRequestApi = (value) => {
  let endPoint = `${path}/get-attendance-user-pending-request`;
  return postData(endPoint, value);
};

export const getUnmarkedAttendanceListApi = (value) => {
  let endPoint = `${path}/get-unmarked-attendance-list`;
  return postData(endPoint, value);
};

export const addrRstrictedHolidayApi = (value) => {
  let endPoint = `${path}/add-restricted-holiday`;
  return postData(endPoint, value);
};

export const getRestrictedHoliadayApi = (value) => {
  let endPoint = `${path}/restricted-holidaylist`;
  return postData(endPoint, value);
};

export const shortLeaveAttendanceApi = (value) => {
  let endPoint = `${path}/shortleave-attendance`;
  return postData(endPoint, value);
};

export const approveAttendanceReportApi = (value) => {
  let endPoint = `${path}/approve-attendance-report`;
  return postData(endPoint, value);
};

export const updateStatusAttendancetApi = (value) => {
  let endPoint = `${path}/update-attendance`;
  return postData(endPoint, value);
};

export const leveAttendanceToEmployeeApi = (value) => {
  let endPoint = `${path}/leave-attendance-employee`;
  return postData(endPoint, value);
};

export const reclassifyAttendanceApi = (value) => {
  let endPoint = `${path}/reclassify-attendance`;
  return postData(endPoint, value);
};

export const addNewShiftApi = (value) => {
  let endPoint = `${path}/shift-management`;
  return postData(endPoint, value);
};

export const shiftReportApi = (value) => {
  let endPoint = `${path}/shift-report`;
  return postData(endPoint, value);
};

export const employeeShiftDetailsApi = (payload) => {
  return postData(`${path}/employee-shift-details`, payload);
};

export const employeeShiftDatesApi = (body) => {
  let endPoint = `${path}/employee-shift-dates`;
  return postData(endPoint, body);
};

export const attendaceReportApi = (value) => {
  let endPoint = `${path}/attendace-report`;
  return postData(endPoint, value);
};

export const attendanceAnalyticsReportApi = (value) => {
  let endPoint = `${path}/attendance-analytics-report`;
  return postData(endPoint, value);
};

export const attendaceCheckInStatusApi = (value) => {
  let endPoint = `${path}/check-in-status`;
  return postData(endPoint, value);
};

export const getTodayCheckinsApi = (value) => {
  let endPoint = `${path}/today-checkins`;
  return postData(endPoint, value);
};

export const saveClientApi = (value) => {
  let endPoint = `${path}/save-client`;
  return postData(endPoint, value);
};

export const getClientApi = (value) => {
  let endPoint = `${path}/get-clients`;
  return postData(endPoint, value);
};

export const saveClientUserApi = (value) => {
  let endPoint = `${path}/save-client-user`;
  return postData(endPoint, value);
};

export const getClientUserApi = (value) => {
  let endPoint = `${path}/get-client-user`;
  return postData(endPoint, value);
};

export const deleteClientApi = (value) => {
  let endPoint = `${path}/delete-client`;
  return postData(endPoint, value);
};

export const deleteClientUserApi = (value) => {
  let endPoint = `${path}/delete-client-user`;
  return postData(endPoint, value);
};

export const saveClientPolicyApi = (value) => {
  let endPoint = `${path}/save-client-leave-policy`;
  return postData(endPoint, value);
};

export const deleteClientPolicyApi = (value) => {
  let endPoint = `${path}/delete-client-leave-policy`;
  return postData(endPoint, value);
};

export const saveEmailScheduleApi = (value) => {
  let endPoint = `${path}/save-email-schedule`;
  return postData(endPoint, value);
};

export const getEmailScheduleApi = (value) => {
  let endPoint = `${path}/get-email-schedule`;
  return postData(endPoint, value);
};

export const deleteEmailScheduleApi = (value) => {
  let endPoint = `${path}/delete-email-schedule`;
  return postData(endPoint, value);
};

export const getTimeSheetApi = (value) => {
  let endPoint = `${path}/get-list-time-sheet`;
  return postData(endPoint, value);
};

export const resendEmailApi = (value) => {
  let endPoint = `${path}/resend-email-time-sheet`;
  return postData(endPoint, value);
};

export const getAllEmployeeUserApi = (value) => {
  let endPoint = `${path}/get-all-employee-users`;
  return postData(endPoint, value);
};

export const getMapEmployeeUserApi = (value) => {
  let endPoint = `${path}/get-all-employee-map-users`;
  return postData(endPoint, value);
};

export const saveEmployeeUserApi = (value) => {
  let endPoint = `${path}/save-employee-user`;
  return postData(endPoint, value);
};

export const getAllBranchUsersApi = (value) => {
  let endPoint = `${path}/get-all-branch-users`;
  return postData(endPoint, value);
};

export const saveHrLocationsApi = (value) => {
  let endPoint = `${path}/save-hr-location`;
  return postData(endPoint, value);
};

export const getHrLocationsApi = (value) => {
  let endPoint = `${path}/get-hr-locations`;
  return postData(endPoint, value);
};

export const deleteHrLocationsApi = (value) => {
  let endPoint = `${path}/delete-hr-location`;
  return postData(endPoint, value);
};
export const deleteShiftManagementApi = (value) => {
  let endPoint = `${path}/delete-shift-management`;
  return postData(endPoint, value);
};
export const getHolidayListApi = (value) => {
  let endPoint = `${path}/holiday-list`;
  return postData(endPoint, value);
};

export const editHolidayApi = (value) => {
  let endPoint = `${path}/edit-holiday`;
  return postData(endPoint, value);
};

export const deleteHolidayApi = (value) => {
  let endPoint = `${path}/delete-holiday`;
  return postData(endPoint, value);
};

export const markRemoteAttendanceApi = (value) => {
  let endPoint = `${path}/remote-mark-attendance`;
  return postData(endPoint, value);
};

export const getEmployeeRegularizeTime = (value) => {
  let endPoint = `${path}/employee-regularize-time-details`;
  return postData(endPoint, value);
};

export const getPayrollSummary = (value) => {
  let endPoint = `${path}/get-payroll-summary`;
  return postData(endPoint, value);
};

export const getPayrollDetailedStatus = (value) => {
  let endPoint = `${path}/get-payroll-detail-status`;
  return postData(endPoint, value);
};

export const saveRoutePointApi = (payload) =>
  postData(`${path}/save-route-point`, payload);

export const getRoutePointsApi = () => postData(`${path}/get-route-points`);

export const deleteRoutePointApi = (payload) =>
  postData(`${path}/delete-route-point`, payload);

export const saveRouteAreaApi = (payload) =>
  postData(`${path}/save-route-area`, payload);

export const getRouteAreasApi = () => postData(`${path}/get-route-areas`);

export const deleteRouteAreaApi = (payload) =>
  postData(`${path}/delete-route-area`, payload);
  
export const saveWorkRouteApi = (payload) =>
  postData("/hrpayroll/save-work-route", payload);

export const previewAutoRoutesApi = (payload) =>
  postData("/hrpayroll/preview-auto-routes", payload);

export const generateAutoRoutesApi = (payload) =>
  postData("/hrpayroll/generate-auto-routes", payload);

export const getWorkRoutesApi = () => postData("/hrpayroll/get-work-routes");

export const getRouteActiveExecutionsApi = (payload) =>
  postData("/hrpayroll/get-route-active-execution-count", payload);

export const deleteWorkRouteApi = (payload) =>
  postData("/hrpayroll/delete-work-route", payload);

export const saveRouteAssignmentApi = (payload) =>
  postData("/hrpayroll/save-route-assignment", payload);

export const getRouteAssignmentsApi = () =>
  postData("/hrpayroll/get-route-assignments");

export const getMyActiveRouteAssignmentApi = (data) =>
  postData("/hrpayroll/get-my-active-route-assignment", data);

export const getRoutePointVisitHistoryApi = (data) =>
  postData("/hrpayroll/get-route-point-visit-history", data);

export const markRouteNotExecutedApi = (data) =>
  postData("/hrpayroll/mark-route-not-executed", data);

export const deleteRouteAssignmentApi = (payload) =>
  postData("/hrpayroll/delete-route-assignment", payload);

export const saveLiveLocationApi = (payload) =>
  postData("/hrpayroll/save-live-location", payload);

export const getLiveLocationsApi = (payload) =>
  postData("/hrpayroll/get-live-locations", payload);

export const saveRouteVisitLogApi = (payload) =>
  postData("/hrpayroll/save-route-visit-log", payload);

export const getRouteVisitLogsApi = (payload) =>
  postData("/hrpayroll/get-route-visit-logs", payload);

export const getRouteReplayDataApi = (payload) =>
  postData("/hrpayroll/get-route-replay-data", payload);

export const getRouteVisitReportApi = (payload) =>
  postData("/hrpayroll/get-route-visit-report", payload);

export const startRouteSessionApi = (value) => {
  return postData(`${path}/start-route-session`, value);
};

export const convertAdhocToRoutePointApi = (payload) =>
  postData("/hrpayroll/convert-adhoc-to-route-point", payload);

export const getActiveRouteSessionApi = (value) => {
  return postData(`${path}/get-active-route-session`, value);
};

export const checkinRoutePointApi = (value) => {
  return postData(`${path}/checkin-route-point`, value);
};

export const checkoutRoutePointApi = (value) => {
  return postData(`${path}/checkout-route-point`, value);
};

export const checkinAdhocVisitApi = (payload) =>
  postData("/hrpayroll/checkin-adhoc-visit", payload);

export const checkoutAdhocVisitApi = (payload) =>
  postData("/hrpayroll/checkout-adhoc-visit", payload);

export const getActiveAdhocVisitApi = (payload) =>
  postData("/hrpayroll/get-active-adhoc-visit", payload);

export const getAdhocVisitsApi = (payload) =>
  postData("/hrpayroll/get-adhoc-visits", payload);

export const completeRouteSessionApi = (value) => {
  return postData(`${path}/complete-route-session`, value);
};

export const getRouteProgressApi = (value) => {
  return postData(`${path}/get-route-progress`, value);
};

export const getWorkRouteAnalyticsApi = async (value) => {
  return postData(`${path}/get-work-route-analytics`, value);
};

export const checkEmployeeRouteAccessApi = async () => {
  return postData("/hrpayroll/check-employee-route-access");
};

export const getMyRouteScheduleApi = (payload) => {
  return postData("/hrpayroll/get-my-route-schedule", payload);
};